import React, {useEffect, useState} from 'react'

import userColored from '../../../Logo/user-coloured.svg';
import cart from "../../../Logo/cart.svg"
import cartBlack from "../../../Logo/cart_blck.svg"
import drillcut360 from "../../../image/360_SVG.svg";
import {
    Avatar,
    AvatarBadge,
    AvatarGroup,
    Badge,
    Box,
    Button,
    Flex,
    Image,
    Menu,
    MenuButton,
    MenuDivider,
    MenuGroup,
    MenuItem,
    MenuItemOption,
    MenuList,
    MenuOptionGroup,
    Spacer,
    Stack,
    Tab,
    TabList,
    Tabs,
    Tooltip
} from '@chakra-ui/react'
import {Link as ReactRouterLink, useNavigate} from 'react-router-dom';
import { forwardRef } from 'react';
import {replaceurlbystore, ShopifyStoreFrontAccessToken, ShopifyStoreLink} from "../../../GlobalVar";
import {SearchInstantBox} from './SeachInstantBox'
import {MenuNavigation} from '../navigation/MenuNavigation'
import {CheckCircleIcon} from "@chakra-ui/icons";
import {useDispatch, useSelector} from "react-redux";
import {useQuery} from "react-query";
import {laravelAxios} from "../../apiClients/laravelClient";
import {logoutUser, setCartID, setCurrentBranchID, setGlobalCartQuantity} from "../../../store/features/UserSlice";
import {MenuInput} from "../input/MenuInput";
import {isSuperAdmin, scrollToTop} from "../../utils";
import {LoginPopUp} from '../Login_popup_header';
import {shopifyAxios} from "../../apiClients/shopifyClient";
import {CheckCart} from "../../apis/graphql/Cart";
import MainlLogo from "../../../Logo/drillcut-SVG.svg";

export const ChakraLink = forwardRef(({ showBorder, ...rest }, ref) => {
  return <ReactRouterLink ref={ref} {...rest} />;
});

export const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [menu, setmenu] = useState()
    const {isLoggedIn, cartQuantity, currentBranchId, allUserInfo} = useSelector((state) => state.user);
    const [superAdminBranchList, setSuperAdminBranchList] = useState([]);
    // const [allBranchDeatils, setAllBranchDeatils] = useState({});
    // const [branchCount, setBranchCount] = useState(1);
    const [allBranchDetails, setAllBranchDetails] = useState({});

    // const {data: allBranches} = useQuery(['branch_infos', branchCount], () => laravelAxios.get(`/branches?page=${branchCount}`), {
    //     enabled: isLoggedIn, select: res => {
    //         const branchInfo = {}
    //         for (const branch of res.data?.data) {
    //             branchInfo[branch.id] = branch;
    //         }
    //         if (res?.data?.links) {
    //             if (res.data.links.next !== null) {
    //                 setBranchCount(prevState => prevState + 1);
    //             }
    //         }
    //         return branchInfo;
    //     }, refetchOnWindowFocus: false,
    // });

    async function getAllBranches(pageCount = 1) {
        const res = await laravelAxios.get(`/branches?page=${pageCount}`);
        const branchInfo = {}
        for (const branch of res.data?.data) {
            branchInfo[branch.id] = branch;
        }
        if (res?.data?.links) {
            if (res.data.links.next !== null) {
                await getAllBranches(pageCount + 1);
            }
        }
        const branches = Object.keys(branchInfo);
        if (currentBranchId === null || currentBranchId === undefined || currentBranchId === '') {
            dispatch(setCurrentBranchID({
                currentBranchId: branchInfo[branches[0]]?.id,
                currentDebtorId: branchInfo[branches[0]]?.account_number
            }));
        }
        setAllBranchDetails(prevState => {
            return {...prevState, ...branchInfo}
        })
    }

    useEffect(() => {
        if (isLoggedIn) {
            getAllBranches(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);


    useEffect(() => {
        GetMainMenu();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const {data: branchList} = useQuery('branch_list', () => laravelAxios.get('/branch_list'), {
        select: (res) => {
            const branches = []
            for (const dataKey in res.data) {
                branches.push({key: dataKey, value: res.data[dataKey]});
            }
            return branches;
        }, enabled: isLoggedIn, refetchOnWindowFocus: false,
    });

    const GetMainMenu = () => {
        const query = `query MyQuery {
    menu(handle: "main-menu") {
      title
      items {
        url
        title
        type
      }
    }
  }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        })
            .then(response => {
                const data = response.json()
                Promise.all([data]).then((values) => {
                    setmenu(values[0]['data']['menu']['items']);
                });
            })
    }

    const selectCurrentBranch = async (id) => {
        dispatch(setCurrentBranchID({currentBranchId: id, currentDebtorId: allBranchDetails[id]?.account_number}));
        await laravelAxios.put('/updateuser', {
            branch_id: id,
        });
    }

    const logout = () => {
        dispatch(logoutUser());
        navigate('/login');
    }

    const searchByBranchName = async (e) => {
        const {value} = e.target;
        const res = await laravelAxios.get(`/branch_list?search=${value}`);
        const branches = []
        for (const dataKey in res.data) {
            branches.push({key: dataKey, value: res.data[dataKey]});
        }
        setSuperAdminBranchList(branches.slice(0, 10));
    }


    const {refetch: refetchCartInfo} = useQuery('cart-check', () => {
        return shopifyAxios.post('', CheckCart(allUserInfo?.cart_id));
    }, {
        cacheTime: 0,
        enabled: allUserInfo?.cart_id !== '' && isLoggedIn,
        onSuccess: (res) => {
            const value = res.data?.data?.cart;
            if (value === null || value === undefined) {
                dispatch(setGlobalCartQuantity({cartQuantity: 0}));
                dispatch(setCartID({currentCartID: ''}));
            } else {
                const quantity = value['lines']['edges'].length;
                dispatch(setGlobalCartQuantity({cartQuantity: quantity}));
            }
        }
    });

    useEffect(() => {
        refetchCartInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allUserInfo]);

    return (<>
        <Box display={{base: "none", md: "block"}}>
            <Box borderBottom='1px solid #F2F2F2'>
                <Flex borderBottom='none' className='main_header main_container'>
                    <Spacer/>
                    <Spacer/>
                    <Flex>
                        {menu && menu.map((menu, i) => {
                            return (
                                <ReactRouterLink
                                    key={menu.url + '-' + i}
                                    to={menu.url.replace(`${replaceurlbystore}`, '')} rel="noreferrer" className="chakra-tabs__tab">
                                    {menu.title}
                                </ReactRouterLink>
                            )
                        })}
                        <a href="tel:1800374552" style={{paddingRight: "0"}} className='telephone_number_a chakra-tabs__tab'>1800
                            374 552</a>
                    </Flex>
                </Flex>
            </Box>
            <Box>
                <Flex className='main_container header_center_mt' p='20px 0' justifyContent="space-between">
                    <Box>
                        <ReactRouterLink to='/' onClick={scrollToTop}>
                            <Image loading='lazy'
                                   htmlWidth='100%'
                                   htmlHeight='241'
                                   className="footer_logo_main_logo"
                                   src={MainlLogo}
                                   alt='logo'/>
                        </ReactRouterLink>
                    </Box>
                    {/*<Spacer/>*/}
                    <Stack maxW="550px" w="100%" className='log_vertical'>
                        <SearchInstantBox/>
                    </Stack>
                    {/*<Spacer/>*/}

                    <AvatarGroup spacing='1rem'>
                        {isLoggedIn ? (
                            <Menu>
                                <MenuButton as={Avatar} className='header_icons_mt_new_Drillcut icon' bg='white' src={userColored} aria-label="User menu">
                                    <AvatarBadge right={'5px'} top={'-5px'} bottom={'none'} border={'none'} color={'#EC7700'}>
                                        <CheckCircleIcon width={'15px'} height={'15px'} border={'none'}/>
                                    </AvatarBadge>
                                </MenuButton>
                                <MenuList zIndex="999">
                                    <MenuGroup>
                                        <MenuItem as={ReactRouterLink} to="/360/dashboard" margin="0px" padding="0px">
                                            <Image loading="lazy" src={drillcut360} margin="auto" maxH={"35px"} alt="Drillcut 360 Logo" />
                                        </MenuItem>
                                    </MenuGroup>
                                    <MenuDivider borderBottom="2px solid" marginBottom="0px" opacity="1"/>
                                    {isSuperAdmin(allUserInfo) ? (<>
                                        <MenuInput mt="10px" placeHolder="Search Branch Name" changeInput={searchByBranchName}/>
                                        <MenuOptionGroup value={currentBranchId}>
                                            {superAdminBranchList?.map((branch) => (
                                                <MenuItemOption key={branch?.key} mt="10px" value={branch?.key} onClick={() => {
                                                    selectCurrentBranch(branch.key);
                                                    navigate('/360/dashboard');
                                                }}>
                                                    {branch?.value}
                                                </MenuItemOption>))}
                                            <MenuItem borderTop="2px solid" borderColor="inherit" opacity="1" mt="10px" onClick={logout}>Log Out</MenuItem>
                                        </MenuOptionGroup></>) : (
                                        <MenuOptionGroup value={currentBranchId} type='radio' title="Select Branch">
                                            {branchList?.map((branch) => (
                                                <MenuItemOption key={branch?.key} onClick={() => {
                                                    selectCurrentBranch(branch?.key)
                                                    navigate('/360/dashboard');
                                                }} value={branch?.key}>{branch?.value}</MenuItemOption>))}
                                            <MenuItemOption borderTop="2px solid" borderColor="inherit" opacity="1" onClick={logout}>Log Out</MenuItemOption>
                                        </MenuOptionGroup>
                                    )}
                                </MenuList>
                            </Menu>
                        ) : (<LoginPopUp/>)}
                        <Button as={ChakraLink} to='/cart' className="icons_with_text_button" aria-label="View cart">
                            <Avatar className='header_icons_mt_new_Drillcut icon' bg='white' src={cartQuantity ? cart : cartBlack} />
                            <Badge backgroundColor={cartQuantity ? '#EC7700' : 'black'} color="white" right={'0px'} top={'0px'} position="absolute" borderRadius="50%" bottom={'none'} border={'none'}>
                                {cartQuantity ? cartQuantity : 0}
                            </Badge>
                        </Button>
                    </AvatarGroup>
                </Flex>
            </Box>
        </Box>
        <MenuNavigation/>
    </>);
}
